import { fork } from 'redux-saga/effects';
import companySaga from './companySaga';
import engagementSurveySaga from './engagementSurvey';
import segmentSaga from './segmentSaga';
import uiSaga from './uiSaga';
import userSaga from './userSaga';

export default function* backendSaga() {
  yield fork(uiSaga);
  yield fork(userSaga);
  yield fork(engagementSurveySaga);
  yield fork(segmentSaga);
  yield fork(companySaga);
}
